<template>
    <div>
        <div v-if="layoutInfopointList.length === 0" class="no-infopoints">
            {{ $t('infopointlayouts.no_infopoints') }}
        </div>
        <div v-else>
            <div class="infopoint-preview">
                <h6>{{ firstInfopoint.name }} ({{ firstInfopoint.uniqueId }})</h6>
                <InfopointScreenshot :item="firstInfopoint" />
            </div>
        </div>
    </div>
</template>

<script>
import layout from '@/store/displays/layout';
import InfopointScreenshot from '@/components/Devices/Infopoints/InfopointScreenshot.vue';

export default {
    props: ['item'],
    components: {
        InfopointScreenshot
    },
    data() {
        return {
            layoutInfopoints: [],
        };
    },
    beforeCreate() {
        if (!this.$store.state.layout) {
            this.$store.registerModule("layout", layout);
        }
    },
    mounted() {
        this.fetchInfopointLayouts();
    },
    watch: {
        item: {
            handler() {
                this.fetchInfopointLayouts();
            },
            deep: true,
            immediate: true,
        }
    },
    computed: {
        layoutInfopointList() {
            return this.$store.state.layout.layoutInfopoints || [];
        },
        firstInfopoint() {
            return this.layoutInfopointList.length > 0 ? this.layoutInfopointList[0] : null;
        }
    },
    methods: {
        fetchInfopointLayouts() {
            try {
                this.$store.dispatch("layout/getLayoutInfopoints", this.item.id);
                this.layoutInfopoints = [...this.$store.state.layout.layoutInfopoints];
            } catch (error) {
                console.log("Error:", error);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.infopoint-preview {
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #dee2e6;
    
    &:last-child {
        border-bottom: none;
    }
    
    h6 {
        margin-bottom: 0.5rem;
        color: #495057;
    }
}

.no-infopoints {
    text-align: center;
    color: #6c757d;
    font-style: italic;
    padding: 2rem;
}
</style>